import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import Utils from '../../../../../Utils/FormatDate'
import ServiceOrderRating from '../../../ServiceOrders/components/ServiceOrderRating/ManageServiceOrderRating.vue'
import Component from '../../../../../components/toast.vue'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.institution = JSON.parse(localStorage.getItem('institution'))

    await this.getStandardEquipment()
    if (this.institution.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    await Promise.all([
      this.getPendentCalleds(),
      this.getInstitutions(),
      this.getUsers(),
      this.getStandardEquipment(),
      this.getDepartments(),
    ])

    if (this.institution.userType == 6) {
      this.userRequesterId = this.userLogged.id
    }

    if (this.unidades.length == 1) {
      this.unidadeId = this.unidades[0].id
    }

    if (
      this.institution.userType === 2 ||
      this.institution.userType === 3 ||
      this.institution.userType === 8
    ) {
      this.calledStatus = ['Enviado']
      this.filter.status = [0]
    }

    await this.updateTable()

    this.fetchIntervalFn = setInterval(() => {
      this.updateTable()
    }, 300000)

    this.addCalledSocket()

    const calledId = this.$route.query.calledId
    if (calledId) {
      this.calledId = calledId

      this.apiService
        .get(`called/${this.institutionId}/${calledId}`)
        .then((response) => {
          const called = response.content
          this.callFormRating(called)
        })
    }

    const columns = JSON.parse(this.userLogged.calledColumns)
    this.headers = columns ? columns : this.headers

    if (!this.institution.departmentTypes.includes(1)) {
      this.headers = this.headers.filter(
        (x) => x.text != 'Oficina' && x.text != 'Descrição Atividade'
      )
    }
  },

  beforeDestroy() {
    if (this.fetchIntervalFn) {
      clearInterval(this.fetchIntervalFn)
    }
    if (this.calledSocket) {
      this.calledSocket.close()
    }
  },

  data: () => ({
    institution: {},
    localDepartments: [],
    ratings: [
      {
        text: 'Ruim',
        value: 1,
      },
      {
        text: 'Regular',
        value: 2,
      },
      {
        text: 'Bom',
        value: 3,
      },
      {
        text: 'Ótimo',
        value: 4,
      },
    ],
    equipamentSearch: '',
    departmentSearch: '',
    menuLoading: false,
    headMenu: false,
    fetchIntervalFn: null,
    calledId: null,
    totalItensOnPage: 0,
    visible: false,
    buttonDeleteVisible: false,
    dialog: false,
    editDialog: false,
    deleteDialog: false,
    deleteServiceOrderDialog: false,
    serviceOrderRatingDialog: false,
    dialogKey: false,
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    departmentLoading: false,
    usersLoading: false,
    menuStartDate: false,
    menuEndDate: false,
    startDate: null,
    endDate: null,
    calledStartDate: null,
    calledEndDate: null,
    minDate: null,
    calledRatingQuantity: 0,
    expanded: [],
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    departmentId: null,
    departments: [],
    userLogged: {},
    userRequesterId: null,
    users: [],
    calledSelected: [],
    currentCalled: {},
    calleds: [],
    calledRatings: [],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    generalService: new GeneralService(),
    filter: {
      page: 1,
      pageSize: 10,
      institutionId: null,
      unidadeId: null,
      standardEquipaments: null,
      equipment: null,
      serialNumber: null,
      identification: null,
      departmentIds: null,
      status: null,
      startDate: null,
      endDate: null,
      serviceOrderNumber: null,
      propertyCode: null,
      calledNumber: null,
      userRequesterId: null,
      ordination: null,
    },
    standardEquipmentName: null,
    equipmentName: null,
    equipmentSerialNumber: null,
    equipmentIdentification: null,
    serviceOrderNumber: null,
    equipmentPropertyCode: null,
    calledNumber: null,
    calledStatus: [],
    message: '',
    status: ['Enviado', 'Em Andamento', 'Fechado', 'Reprovado'],
    headers: [
      {
        text: 'Número de Série',
        align: 'center',
        value: 'equipment.serialNumber',
        active: false,
        sortable: true,
      },
      {
        text: 'Setor',
        align: 'center',
        value: 'department.name',
        active: false,
        sortable: true,
      },
      {
        text: 'Nº Chamado',
        align: 'center',
        value: 'calledNumber',
        active: true,
        sortable: true,
      },
      {
        text: 'Solicitante',
        align: 'center',
        value: 'userRequester.name',
        active: true,
        sortable: true,
      },
      {
        text: 'Equipamento',
        align: 'center',
        value: 'equipment.name',
        active: true,
        sortable: true,
      },
      {
        text: 'Equip. ID',
        align: 'center',
        value: 'equipment.identification',
        active: true,
        sortable: true,
      },
      {
        text: 'Urgência',
        align: 'center',
        value: 'calledLevelUrgent',
        active: true,
        sortable: true,
      },
      {
        text: 'Data Solicitação',
        align: 'center',
        value: 'createdAt',
        active: true,
        sortable: true,
      },
      {
        text: 'Estado',
        align: 'center',
        value: 'calledStatus',
        active: true,
        sortable: true,
      },
      {
        text: 'Data Estado',
        align: 'center',
        value: 'statusDate',
        active: true,
        sortable: true,
      },
      {
        text: 'Avaliação',
        align: 'center',
        value: 'rating',
        active: true,
        sortable: true,
      },
      {
        text: 'Oficina',
        align: 'center',
        value: 'workshop',
        active: false,
        sortable: true,
      },
      {
        text: 'Descrição Atividade',
        align: 'center',
        value: 'workshopActivities',
        active: false,
        sortable: true,
      },
    ],
    standardEquipments: [],
    headersMobile: [
      {
        text: 'Nº Chamado',
        align: 'center',
        value: 'calledNumber',
      },
      {
        text: 'Solicitante',
        align: 'center',
        value: 'requester',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    isToShow: false,
    pendents: 0,
    standardEquipmentLoading: false,
  }),

  components: {
    ServiceOrderRating,
  },

  methods: {
    removeStandardEquipment(item) {
      this.filter.standardEquipments.splice(item, 1)
      this.filter.standardEquipments = [...this.filter.standardEquipments]
    },

    removeCalledStatus(item) {
      this.calledStatus.splice(this.calledStatus.indexOf(item), 1)
      this.calledStatus = [...this.calledStatus]
    },

    removeDepartment(item) {
      this.filter.departmentIds.splice(
        this.filter.departmentIds.indexOf(item),
        1
      )
      this.filter.departmentIds = [...this.filter.departmentIds]
    },

    updateHeaders() {
      this.menuLoading = true

      const json = JSON.stringify(this.headers)
      this.apiService
        .post('user/saveColumns/called', { columns: json })
        .then(() => {
          let userLogged = JSON.parse(localStorage.getItem('user'))
          userLogged.calledColumns = json
          this.headMenu = false
          localStorage.setItem('user', JSON.stringify(userLogged))
          this.$toast.success('Configuração salva no seu usuário!')
          this.menuLoading = false
        })
        .catch(() => {
          this.menuLoading = false
        })
    },

    async getPendentCalleds() {
      await this.apiService
        .get(`called/pendent-rating/${this.institutionId}`)
        .then((response) => {
          this.pendents = response.content.length
          console.log(response.content)
        })
    },

    exportExcel() {
      this.apiService.post('called/excel', this.filter).then((response) => {
        var excelResult = `data:application/octet-stream;base64,${response.content}`
        const link = document.createElement('a')
        link.href = excelResult
        link.setAttribute('download', `Chamados.xlsx`)
        document.body.appendChild(link)
        link.click()
      })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(
          `unidade/listByUserAndInstitution/${this.institutionId}`,
          true,
          false
        )
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    addCalled() {
      window.open(`/newCalled`, '_blank')
    },

    showNotif() {
      this.apiService
        .get(`called/pendent-rating/${this.institutionId}`)
        .then((response) => {
          this.userLogged.pendingCalleds = response.content
          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))
        })

      this.$toast(Component, {
        position: 'top-right',
        timeout: 10000,
        closeOnClick: false,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: false,
        draggablePercent: 0.6,
        showCloseButtonOnHover: true,
        closeButton: 'button',
        icon: true,
        rtl: false,
      })
    },

    editCalled(called) {
      this.currentCalled = called
      window.open(`/editCalled/${this.currentCalled.id}`, '_blank')
    },

    deleteCalled(called) {
      this.currentCalled = called
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    callFormRating(called, toShow) {
      this.isToShow = toShow
      this.currentCalled = called
      this.currentCalled.rating = this.currentCalled.serviceOrderRatings[0]
      this.dialogKey = !this.dialogKey
      this.serviceOrderRatingDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.serviceOrderRatingDialog = false
      this.getPendentCalleds()
      this.updateTable()
      // this.getCalledRatings()
    },

    isInactive(value) {
      let result = ''
      if (value.equipment) {
        value.equipment.department.status == 1 ? 'departmentInactive' : ''
      }
      return result
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.standardEquipment = this.standardEquipmentName
      this.filter.equipment = this.equipmentName
      this.filter.serialNumber = this.equipmentSerialNumber
      this.filter.identification = this.equipmentIdentification
      this.filter.status = this.calledStatus.map((x) => this.status.indexOf(x))
      this.filter.startDate = this.calledStartDate
      this.filter.endDate = this.calledEndDate
      this.filter.serviceOrderNumber = this.serviceOrderNumber
      this.filter.propertyCode = this.equipmentPropertyCode
      this.filter.calledNumber = this.calledNumber

      this.updateTable()
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    getUrgencyClass(urgency) {
      switch (urgency) {
        case 0:
          return 'high'
        case 1:
          return 'median'
        case 2:
          return 'low'
        default:
          return ''
      }
    },

    getUrgency(urgency) {
      switch (urgency) {
        case 0:
          return 'Alta'
        case 1:
          return 'Média'
        case 2:
          return 'Baixa'
        default:
          return ''
      }
    },

    getStatusClass(status) {
      switch (status) {
        case 0:
          return 'sent'
        case 1:
          return 'inProgress'
        case 2:
          return 'closed'
        default:
          return ''
      }
    },

    getStatus(status) {
      switch (status) {
        case 1:
          return 'Em Andamento'
        case 2:
          return 'Fechado'
        case 3:
          return 'Reprovado'
        default:
          return 'Enviado'
      }
    },

    getLastStep(item) {
      if (item.serviceOrder) {
        if (item.serviceOrder.status == 1) {
          return null
        }
        const services = item.serviceOrder.services

        if (services && services.length > 0) {
          const lastStep =
            services.find((s) => s.isMainStep === true) || services[0]

          if (lastStep) {
            switch (lastStep.statusStepServiceOrder) {
              case 0:
                return 'Manutenção terceirizada in loco'
              case 1:
                return 'Manutenção terceirizada externa'
              case 2:
                return 'Manutenção interna'
              case 3:
                return 'Aguardando peça'
              case 4:
                return 'Aguardando orçamento'
              case 5:
                return 'Aguardando avaliação externa'
              case 6:
                return 'Aguardando aprovação de orçamento'
              case 7:
                return 'Aguardando liberação do setor'
              case 8:
                return 'Deslocamento'
              case 9:
                return 'Equipamento não encontrado'
              default:
                return null
            }
          }
        }
      }
    },

    getStatusDate(item) {
      if (item.serviceOrder) {
        if (item.serviceOrder.services.length > 0) {
          const lastStep =
            item.serviceOrder.services[item.serviceOrder.services.length - 1]
          return this.formatDate(lastStep.dateTimeStartStep)
        }
        if (item.serviceOrder.status == 1) {
          return this.formatDate(item.serviceOrder.closeServiceOrderDateTime)
        }
        return this.formatDate(item.serviceOrder.createAt)
      } else if (item.calledStatus == 3) {
        return this.formatDate(item.disaprovedDate)
      } else if (item.calledStatus == 2) {
        return this.formatDate(item.updatedAt)
      } else {
        return this.formatDate(item.createdAt)
      }
    },

    deleteManyCalled() {
      this.calledSelected.map((called) => {
        if (called.serviceOrderId != null) {
          this.deleteServiceOrderDialog = true
          this.deleteDialog = false
        } else {
          this.removeCalled()
        }
      })
    },

    getRating(called) {
      const calledRating = this.calledRatings.find(
        (x) => x.calledId == called.id
      )
      if (calledRating) {
        return calledRating.rating
      }
    },

    getAllRating(called) {
      const calledRating = this.calledRatings.find(
        (x) => x.calledId == called.id
      )
      if (calledRating) {
        return calledRating
      }
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getUsers() {
      this.userLoading = true

      await this.apiService
        .get(`user/list/${this.institutionId}`)
        .then((response) => {
          this.users = response.content
          this.userLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
          this.localDepartments = this.departments
          this.departmentLoading = false
        })
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId
      this.filter.requesterUserId = this.userRequesterId

      await this.apiService
        .post('called/list', this.filter, false, false, false)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.calleds = response.content.calleds
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.calleds.length
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async getCalledRatings() {
      await this.apiService.get('called/getRatings').then((response) => {
        this.calledRatings = response.content
      })
    },

    async removeCalled() {
      this.loading = true

      await this.apiService
        .delete('called/deleteCalled', this.calledSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.message = err.message
        })
      this.calledSelected = []
      this.deleteDialog = false
      this.deleteServiceOrderDialog = false
      this.loading = false
    },

    async removeCalledAndOs() {
      this.loading = true

      await this.apiService
        .delete('called/deleteCalledServiceOrder', this.calledSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.message = err.message
        })

      this.calledSelected = []
      this.deleteDialog = false
      this.deleteServiceOrderDialog = false
      this.loading = false
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        institutionId: JSON.parse(localStorage.getItem('institution')).id,
        unidadeId: null,
        standardEquipament: null,
        equipment: null,
        serialNumber: null,
        identification: null,
        departmentIds: null,
        status: null,
        startDate: null,
        endDate: null,
        serviceOrderNumber: null,
        propertyCode: null,
        calledNumber: null,
        userRequesterId: null,
      }
      this.institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.unidadeId =
        this.institution.userType == 5 || this.institution.userType == 6
          ? this.userLogged.unidadeId
          : null
      this.departmentId = null
      this.userRequesterId =
        this.institution.userType == 6 ? this.userLogged.id : null
      this.standardEquipmentName = null
      this.equipmentName = null
      this.equipmentSerialNumber = null
      this.equipmentIdentification = null
      this.serviceOrderNumber = null
      this.equipmentPropertyCode = null
      this.calledNumber = null
      this.calledStatus = []
      this.startDate = null
      this.endDate = null

      this.updateTable()
    },

    formatDate(date) {
      if (date) {
        return Utils.dateTime(date)
      }
      return 'Sem registros'
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.calledStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.calledStartDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.calledEndDate)
      this.$refs.menuEndDate.save(date)
    },

    addCalledSocket() {
      if (this.calledSocket) {
        return
      }
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      this.calledSocket = new WebSocket(
        `${process.env.VUE_APP_BASE_URL_SOCKET}?chatId=institution-${institutionId}`
      )

      const $context = this

      this.calledSocket.onmessage = async function () {
        $context.updateTable()
      }
    },
  },

  watch: {
    $route() {
      const calledId = this.$route.query.calledId

      if (calledId) {
        this.calledId = calledId
        this.apiService
          .get(`called/${this.institutionId}/${calledId}`)
          .then((response) => {
            const called = response.content
            this.callFormRating(called)
          })
      }
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = this.page
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    calledSelected() {
      if (this.institution.userType <= 2 || this.institution.userType == 8) {
        this.buttonDeleteVisible = this.calledSelected.length > 0
      }
    },
  },
}
